import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

const getEmployers = async (params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.EMPLOYERS.EMPLOYERS, {params});
	return response.data;
};

const getEmployerByID = async (id: any, params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.EMPLOYERS.EMPLOYER_BY_ID + id, {params});
	return response.data;
};

const createEmployer = async (data: any) => {
	data.showInfo = data.showInfo ? 1 : 0;
	const response = await axiosClient.post(api.CAREER_CENTER.EMPLOYERS.EMPLOYERS, formData(data, 'ADD'));
	return response.data;
};

const updateEmployer = async (id: any, data: any) => {
	data.showInfo = data.showInfo ? 1 : 0;
	const response = await axiosClient.patch(api.CAREER_CENTER.EMPLOYERS.EMPLOYER_BY_ID + id, formData(data));
	return response.data;
};

const deleteEmployers = async (ids: any) => {
	const response = await axiosClient.delete(api.CAREER_CENTER.EMPLOYERS.EMPLOYERS_BY_IDS + ids);
	return response.data;
};

const service = {
	getEmployers,
	getEmployerByID,
	createEmployer,
	updateEmployer,
	deleteEmployers
};

export default service;
